import {
  Pillar
} from '../models';

import {
  mapRelationships
} from './common-mapper';

export const mapPillarMeta = (result) => {

  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included)
        }
      };
    })
    .map((pillar) => {
      return new Pillar(pillar).mapToStandard();
    });
};
